import { theme } from "@tm/utility/global";
import styled from "styled-components";
import {
  cardBodyValueStyle,
  cardCaptionStyle,
  cardHeaderTitleStyle,
} from "./CancelPolicyStepCards.style";

const PLAN_BAND_BACKGROUND = "#FFF5F5";

export const planDetailsHeaderTitleStyle = cardHeaderTitleStyle;

export const planTitleStyle = {
  color: theme.blackText,
  fontSize: "16px",
  lineHeight: "20px",
  fontWeight: 700,
};

export const planProviderStyle = cardCaptionStyle;

export const detailLabelStyle = {
  color: theme.greyText,
  fontSize: "14px",
  lineHeight: "18px",
  fontWeight: 400,
};

export const detailValueStyle = {
  ...cardBodyValueStyle,
  fontSize: "14px",
  lineHeight: "18px",
  fontWeight: 700,
};

export const PlanDetailsHeader = styled.div`
  padding: 16px 16px 0;
`;

export const PlanBand = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 12px 16px 4px;
  padding: 12px;
  background: ${PLAN_BAND_BACKGROUND};
  border-radius: 8px;
`;

export const PlanIcon = styled.img`
  height: 40px;
  width: auto;
  max-width: 120px;
  border-radius: 4px;
  object-fit: contain;
  flex-shrink: 0;
`;

export const PlanText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const PlanDetailsList = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px 16px 16px;
`;

export const PlanDetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px dashed ${theme.lightSilver};

  &:last-child {
    border-bottom: 0;
  }
`;

export const PlanDetailLabelCell = styled.div`
  flex-shrink: 1;
  min-width: 0;
`;
